import { ptBrCommonFieldsTranslations } from "../common";

export const message = {
  name: "Mensagem |||| Mensagens",
  fields: {
    body: "Conteúdo",
    type: "Tipo",
    status: "Status",
    sender: "Remetente",
    createdAt: ptBrCommonFieldsTranslations.createdAt,
  },
  types: {
    text: "Texto",
    image: "Imagem",
    video: "Vídeo",
    audio: "Áudio",
    document: "Documento",
    location: "Localização",
    live_location: "Localização ao vivo",
    contact: "Contato",
    poll: "Enquete",
    sticker: "Figurinha",
    system: "Sistema",
  },
  status: {
    processing: "Processando",
    pending: "Pendente",
    sent: "Enviada",
    received: "Entregue",
    read: "Lida",
    played: "Reproduzida",
    failed: "Falhou",
  },
  statusHistory: {
    title: "Histórico de Status",
    empty: "Nenhum histórico de status disponível",
    clickToView: "Clique para ver histórico de status",
    sending: "Enviando...",
  },
  editHistory: {
    title: "Histórico de Edições",
    empty: "Esta mensagem não foi editada",
    version: "Versão %{smart_count}",
    currentVersion: "Versão Atual",
    current: "Atual",
    emptyContent: "(mensagem vazia)",
  },
  actions: {
    editHistory: "Histórico de Edições",
    statusHistory: "Histórico de Status",
    reply: "Responder",
    forward: "Encaminhar",
    react: "Reagir",
    copy: "Copiar",
    edit: "Editar",
    delete: "Excluir",
    retry: "Reenviar",
    sendFailed: "Falha ao enviar",
  },
  notifications: {
    copied: "Copiado para a área de transferência",
    copyFailed: "Falha ao copiar",
    editSuccess: "Mensagem editada",
    deleteSuccess: "Mensagem excluída",
  },
  reactions: {
    moreEmojis: "Mais emojis",
    backToQuick: "← Reações rápidas",
    remove: "Remover reação",
  },
  dialogs: {
    deleteTitle: "Excluir Mensagem",
    deleteConfirmation: "Tem certeza que deseja excluir esta mensagem? Esta ação não pode ser desfeita.",
    deleteTimeRemaining: "Você tem %{time} para excluir esta mensagem",
    hardDeleteLabel: "Excluir para todos (remove o conteúdo da mensagem)",
    hardDeleteHint: "A mensagem aparecerá como \"excluída\" mas o conteúdo será removido permanentemente.",
    editTitle: "Editar Mensagem",
    editPlaceholder: "Editar mensagem...",
    editTimeRemaining: "Você tem %{time} para editar esta mensagem",
  },
};
